import React, { ReactNode } from 'react';
import { Badge as MuiBadge } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from './Badge.style';

interface BadgePropsModel {
  badgeContent: ReactNode;
  className?: string;
  testId?: string;
}

const BadgeContent = ({ badgeContent }: { badgeContent: ReactNode }) => {
  const c = useStyles({});
  return (
    <span className={c.badgeContent}>
        {badgeContent}
    </span>
  )
}

export const Badge = ({ badgeContent, className, testId }: BadgePropsModel) => {
  const c = useStyles({});
  return (
    <MuiBadge
      badgeContent={<BadgeContent badgeContent={badgeContent} />}
      className={clsx(c.root, className)}
      data-type="ui/badge"
      data-testid={testId}
    />
  );
};